export default [
    {
        name: 'queryWarehouseQuoteLists',
        url: '/lists'
    },
    {
        name: 'deleteWarehouseQuote',
        url: '/delete'
    }
];
